import React from 'react';
import { Link } from 'react-router-dom';

const base =
  'inline-flex items-center justify-center gap-2 rounded-lg px-6 py-3 text-[15px] font-semibold transition-colors transition-shadow duration-200 ease-out focus-visible:outline-none';

const variants = {
  primary: 'bg-ophir-navy text-white hover:bg-ophir-navy-deep shadow-sm hover:shadow-md',
  secondary:
    'border border-ophir-navy text-ophir-navy bg-white hover:bg-ophir-ivory',
  gold: 'bg-ophir-gold text-ophir-navy-deep hover:bg-ophir-gold-soft font-bold',
  ghost: 'text-ophir-navy hover:text-ophir-navy-deep underline underline-offset-4 decoration-ophir-grey-med hover:decoration-ophir-gold px-0 py-0',
};

export const OphirButton = ({
  variant = 'primary',
  to,
  href,
  children,
  className = '',
  type,
  ...props
}) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button type={type || 'button'} className={cls} {...props}>{children}</button>;
};
